import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { AlertController, LoadingController, Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { ErrorHandling } from '../shared/error.handling';
import { TranslateCategoryPipe } from '../shared/translate-category.pipe';
import { ConfigService } from './config';
import { UserService } from './user';

@Injectable()
export class SearchService {

    results: any[];
    offsetCounter: any; // top
    config: any = {};

    constructor(public http: Http,
                public loadingCtrl: LoadingController,
                public alertCtrl: AlertController,
                public datePipe: DatePipe,
                public platform: Platform,
                public errorHandling: ErrorHandling,
                public configService: ConfigService,
                public userService: UserService) {

        this.config = configService.getConfig();
        this.offsetCounter = parseInt(localStorage.getItem('settings.offsetCounter'));
    }

    /**
     * Loads external favorites
     * @param {string} orgaStructure
     * @returns {Observable<any>}
     */
    externalFavourites(): Observable<any> {
        let storedtoken = localStorage.getItem('nodetoken');
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedtoken);

        let parameter = 'organizationStructures=Structure&organizationStructures=Folder&organizationStructures=Document&organizationStructures=Address&organizationStructures=Meeting';

        return this.http.get(storedendpoint.apiendpoint + 'favourites?' + parameter + '', {headers: headers})
            .map((response: any) => {
                let result = response.json();
                return result;
            }, (error) => {
                console.error('Favourites -> Error: ', error)
            });
    }

    /**
     * Starts search on server
     * @param {string} searchTerm
     * @param {string} dataSetType
     * @param filter
     * @param {string} sort
     * @param skip
     * @param {string} hierachieField
     * @param searchSecondary -> untergordnete Ergebnisse anzeigen?
     * @returns {Observable<any>}
     */
    search(searchTerm: string, dataSetType: string, filter: any, sort?: string, skip?: any, hierachieField?: string, searchSecondary?: boolean): Observable<any> {

        let storedtoken = localStorage.getItem('nodetoken');
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));
        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedtoken);

        if (!skip) {
            skip = 0;
        }

        // TODO: auf key settings umstellen mit Objekt als value {settings: {"offsetcounter": "20", "anykey": "true", "coming": "soon"}}
        this.offsetCounter = parseInt(localStorage.getItem('settings.offsetCounter'));

        // Standardsuche von Suchseite aus
        let queryParameters = dataSetType + '=true&searchText=' + searchTerm + '&top=' + this.offsetCounter + '&skip=' + skip;

        if (filter) {
            queryParameters += this.addSearchFilters(filter, dataSetType);
        }

        // gespeicherte Sortierung holen und auslesen
        let storedSort = JSON.parse(localStorage.getItem('sorting'));
        let tempSort = storedSort[dataSetType];
        queryParameters += '&fields=Datum,SubVorgangsverwaltung,SubSchriftgutverwaltung,SubAktenplanverwaltung&sortFields=' + tempSort;

        // Suche nach Hierachiefeldern in Details (Buttons/Verknüpfungen)
        if (hierachieField) {
            queryParameters = dataSetType + '=true&searchFields=' + hierachieField + ' equals ' + searchTerm + '&top=' + this.offsetCounter + '&skip=' + skip;
        }

        // Bei der Suche in hierarchischen Strukturen kann hier 'true' oder 'false' angegeben werden,
        // bei 'true' wird nur in der ersten Hierarchie-Ebene gesucht,
        // Objekte untergeordneter Ebenen werden ausgeblendet.

        // Einstellungen für searchLevel1 aus localStorage auslesen (Benutzereinstellung)
        let searchLevelParameter = JSON.parse(localStorage.getItem('settings.searchLevel1'));
        if (searchLevelParameter == 1) {

            // searchLevel1 explizit überschreiben
            // um untergeordnete Ergebisse anzuzeigen
            if (searchSecondary == true) {
                queryParameters += '&searchLevel1=false';
            } else {
                queryParameters += '&searchLevel1=true';
            }

        } else {
            queryParameters += '&searchLevel1=false';
        }

        // globale Suche
        if (dataSetType == 'Global') {
            queryParameters = 'searchText=' + searchTerm + '&Folder=true&Address=true&Structure=true&Document=true&Meeting=true&top=' + this.offsetCounter + '&skip=' + skip;
        }

        return this.http.get(storedendpoint.apiendpoint + 'search?' + encodeURI(queryParameters), {headers: headers})
            .map((response: any) => {
                let results = response.json();

                if (dataSetType != 'Global') {
                    if (results[dataSetType].TotalCount != 0 && results[dataSetType].objDatasets) {
                        let resultList = this.userService.objectKeysChangeCase(results[dataSetType].objDatasets, 'upper');

                        return {
                            results: resultList,
                            resultTotalCount: results[dataSetType].TotalCount,
                            searchLevel1: results[dataSetType].searchLevel1,
                            searchSecondary: searchSecondary
                        };
                    } else {
                        let translateCategoryPipe = new TranslateCategoryPipe();
                        let searchCategoryString = translateCategoryPipe.transform(dataSetType);
                        let customError = {
                            status: 907,
                            _body: 'Keine zugeordneten ' + searchCategoryString + ' gefunden.'
                        };
                        this.errorHandling.handle(customError, 'provider/search -> search()');

                        return false;
                    }
                } else {
                    var tempObjDatasets: any = [];
                    var tempTotalCount: number = 0;

                    Object.keys(results).forEach(function (key, index) {
                        if (results[key].TotalCount > 0) {
                            tempObjDatasets.push(...results[key].objDatasets);
                            tempTotalCount = tempTotalCount + results[key].TotalCount;
                        }
                    });

                    let resultList = this.userService.objectKeysChangeCase(tempObjDatasets, 'upper');

                    if (tempTotalCount > 0) {
                        return {
                            results: resultList,
                            resultTotalCount: tempTotalCount,
                            searchLevel1: 0,
                            searchSecondary: searchSecondary
                        };
                    } else {
                        return false;
                    }
                }
            }, (error) => {
                console.error(error);
            })
    }

    // Suche in Hierachiefeldern: Adresskennung, Teilakten/Vorgänge, Aktenzeichen, Schriftstück, Sizungen
    /**
     * Searches in hierarchy fields
     * @param {string} searchTerm
     * @param {string} dataSetType
     * @param hierarchyField
     * @param skip
     * @param noHierarchy
     * @returns {Observable<any>}
     */
    searchHierarchy(searchTerm: string, dataSetType: string, hierarchyField: any, skip?: any, noHierarchy?: boolean): Observable<any> {
        let storedtoken = localStorage.getItem('nodetoken');
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedtoken);

        if (!skip) {
            skip = 0;
        }

        this.offsetCounter = parseInt(localStorage.getItem('settings.offsetCounter'));

        // gespeicherte Sortierung auslesen
        let storedSort = JSON.parse(localStorage.getItem('sorting'));
        let tempSort = storedSort[dataSetType];

        // Subfelder auslesen um vorhandene Unterobjecte anzeigen zu können
        let fields = '&fields=Datum,SubVorgangsverwaltung,SubSchriftgutverwaltung,SubAktenplanverwaltung' + '&sortFields=' + tempSort;

        // noHierarchy
        let nohierarchy = '&noHierarchy=false';
        if (noHierarchy) {
            nohierarchy = '&noHierarchy=' + noHierarchy.toString();
        }

        let queryParameters = dataSetType + '=true&searchFields=' + hierarchyField +
            encodeURIComponent(' equals ') +
            encodeURIComponent(searchTerm) +
            '&top=' + this.offsetCounter +
            '&skip=' + skip +
            nohierarchy + fields;

        return this.http.get(storedendpoint.apiendpoint + 'search?' + queryParameters, {headers: headers})
            .map((response: any) => {

                let results = response.json();

                if (results[dataSetType].TotalCount > 0) {
                    let resultList = this.userService.objectKeysChangeCase(results[dataSetType].objDatasets, 'upper');
                    return {results: resultList, resultTotalCount: results[dataSetType].TotalCount, searchLevel1: results[dataSetType].searchLevel1};
                } else {
                    let translateCategoryPipe = new TranslateCategoryPipe();
                    let searchCategoryString = translateCategoryPipe.transform(dataSetType);
                    let customError = {
                        status: 907,
                        _body: 'Keine zugeordneten ' + searchCategoryString + ' gefunden.'
                    };
                    this.errorHandling.handle(customError, 'provider/search -> searchHierarchy()');

                    return false;
                }
            }, (error) => {
                console.error(error);
            })
    }

    /**
     * Adds search filters
     * @param filter
     * @param {string} dataSetType
     * @returns {string}
     */
    addSearchFilters(filter: any, dataSetType: string): string {
        let queryFilter = '';

        switch (dataSetType) {
            case 'Structure':
                let filterStructure = filter[dataSetType];
                if (filterStructure && filterStructure.Aktenzeichen) {
                    queryFilter += '&searchFields=Aktenzeichen equals ' + filter[dataSetType].Aktenzeichen + '*';
                }
                break;
            case 'Folder':
                let filterFolder = filter[dataSetType];
                if (filterFolder && filterFolder.Aktenzeichen) {
                    queryFilter += '&searchFields=Aktenzeichen equals ' + filterFolder.Aktenzeichen + '*';
                }
                if (filterFolder && filterFolder.Adresskennung) {
                    queryFilter += '&searchFields=Adresskennung equals ' + filterFolder.Adresskennung;
                }
                break;
            case 'Document':
                let filterDocument = filter[dataSetType];

                if (filterDocument && filterDocument.Aktenzeichen) {
                    queryFilter += '&searchFields=Aktenzeichen equals ' + filter[dataSetType].Aktenzeichen + '\\sa';
                }
                if (filterDocument && filterDocument.Adresskennung) {
                    queryFilter += '&searchFields=Adresskennung equals ' + filter[dataSetType].Adresskennung + '\\sa';
                }
                if (filterDocument && filterDocument.vonDatum && !filterDocument.bisDatum) {
                    queryFilter += '&searchFields=ADatum equals ' + this.datePipe.transform(filter[dataSetType].vonDatum, 'dd.MM.yyyy') + '\\>';
                }
                if (filterDocument && filterDocument.bisDatum && !filterDocument.vonDatum) {
                    queryFilter += '&searchFields=ADatum equals ' + this.datePipe.transform(filter[dataSetType].bisDatum, 'dd.MM.yyyy') + '\\<';
                }
                if (filterDocument && filterDocument.bisDatum && filterDocument.vonDatum) {
                    queryFilter += '&searchFields=ADatum equals ' + this.datePipe.transform(filter[dataSetType].vonDatum, 'dd.MM.yyyy') + ';' + this.datePipe.transform(filter[dataSetType].bisDatum,
                        'dd.MM.yyyy') + '\\-';
                }
                break;
            case 'Address':
                let filterAddress = filter[dataSetType];
                if (filterAddress && filterAddress.Vorname) {
                    queryFilter += '&searchFields=Vorname equals ' + filterAddress.Vorname;
                }
                if (filterAddress && filterAddress.Nachname) {
                    queryFilter += '&searchFields=Nachname equals ' + filterAddress.Nachname;
                }
                if (filterAddress && filterAddress.Strasse) {
                    queryFilter += '&searchFields=Strasse equals ' + filterAddress.Strasse;
                }
                if (filterAddress && filterAddress.StrOrt) {
                    queryFilter += '&searchFields=StrOrt equals ' + filterAddress.StrOrt;
                }
                break;
            case 'Meeting':
                let filterMeeting = filter[dataSetType];

                if (filterMeeting && filterMeeting.vonDatum && !filterMeeting.bisDatum) {
                    queryFilter += '&searchFields=Sitzungsdatum equals ' + this.datePipe.transform(filter[dataSetType].vonDatum, 'dd.MM.yyyy') + '\\>';
                }
                if (filterMeeting && filterMeeting.bisDatum && !filterMeeting.vonDatum) {
                    queryFilter += '&searchFields=Sitzungsdatum equals ' + this.datePipe.transform(filter[dataSetType].bisDatum, 'dd.MM.yyyy') + '\\<';
                }
                if (filterMeeting && filterMeeting.bisDatum && filterMeeting.vonDatum) {
                    queryFilter += '&searchFields=Sitzungsdatum equals ' + this.datePipe.transform(filter[dataSetType].vonDatum,
                        'dd.MM.yyyy') + ';' + this.datePipe.transform(filter[dataSetType].bisDatum, 'dd.MM.yyyy') + '\\-';
                }
                break;
            default:
                break;
        }

        return queryFilter === '&searchFields=' ? '' : queryFilter;
    }

    // field definition
    setFields(cat) {

        let fields: any = [];

        switch (cat) {

            case 'Structure':
                fields = ['Aktenzeichen', 'Text', 'SubVorgangsVerwaltung', 'SubSchriftgutverwaltung', 'ArtID', 'Fussnote',
                    'Haushaltsstelle', 'Hinweise', 'HistAktenzeichen', 'Produktkennung', 'Schlagworte', 'Zustaendigkeit']
                break;

            case 'Folder':
                fields = ['Aktenzeichen', 'Vorgangskennung', '_ObjId', 'Text', 'SubSchriftgutverwaltung', 'BeginnDatum', 'EndeDatum', 'Adresskennung',
                    'ArtID', 'AufbArchiv', 'AufbFrist', 'AufbOrt', 'AufbRegistratur', 'AufbVernichten', 'Barcode', 'BeginnDatum', 'EndeDatum',
                    'Hinweise', 'Schlagworte', 'Status', 'Zustaendigkeit']
                break;

            case 'Document':
                fields = ['Aktenzeichen', 'Vorgangskennung', '_ObjId', 'Text', 'Adresskennung', 'Datum', 'ADatum', 'ArtID', 'AufbArchiv', 'AufbFrist',
                    'AufbOrt', 'AufbRegistratur', 'AufbVernichten', 'Barcode', 'Datum', 'Hinweise', 'Internet', 'InternetBis', 'InternetFreigabe',
                    'InternetVon', 'Kategorie', 'Kennung', 'Postausgang', 'PostDatum', 'Posteingang', 'PostKennung', 'Sachbearbeiter',
                    'SachbErsteller', 'SachbUnterzeichner', 'Schlagworte', 'Schriftstueckidentifikation', 'Status', 'Verknuepfungsart']
                break;

            case 'Address':
                fields = ['Adresskennung', 'SubVorgangsVerwaltung', 'SubSchriftgutverwaltung', 'Strasse', 'StrPLZ',
                    'StrOrt', 'StrLand', 'TelefonPrivat', 'TelefonGesch', 'TelefonMobil', 'MailPrivat', 'MailGesch',
                    'WebAdresse', 'FaxGesch', 'Abteilung', 'Anrede', 'Vorname', 'Nachname', 'Anrede2', 'Nachname2',
                    'Vorname2', 'PartnerAnrede', 'GebDatum', 'GebLand', 'GebName', 'GebOrt', 'Geschlecht', 'Hinweise',
                    'Nachtitel', 'Nachtitel2', 'Namenszusatz', 'Namenszusatz2', 'Ortsteil', 'Postfach', 'Schlagworte',
                    'Staatsangehoerigkeit', 'StrInfoPrivat', 'StrassePrivat', 'StrPLZPrivat', 'StrOrtPrivat', 'FaxPrivat']
                break;

            case 'Meeting':
                fields = ['Aktenzeichen', 'SubSchriftgutverwaltung', 'Sitzungskennung', 'Text', 'Sitzungsdatum', 'SitzungsUhrzeitVon',
                    'SitzungsUhrzeitBis', 'Sitzungsraum', 'Sitzungsgremium', 'ArtID', 'Barcode', 'Bearbeitungsweg', 'ExternIdentifikation',
                    'Hinweise', 'Sitzungsgremium', 'Sitzungsstatus',]
                break;

            default:
                fields = ['Text', 'Adresskennung'];
        }

        return fields;

    }

    // single Object by Id
    getItemById(itemId: string, dataSetType: string): Observable<any> {
        let storedtoken = localStorage.getItem('nodetoken');
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedtoken);

        // Fields depending on folder structure
        let fields = this.setFields(dataSetType).toString();

        return this.http.get(storedendpoint.apiendpoint + 'organizations/' + dataSetType + '/objects?objectIds=' + encodeURI(itemId) + '&fields=' + fields, {headers: headers})
            .map((response) => {
                let results: any = response.json();
                return results;
            });
    }

    /**
     * Get multiple objects (list) by id from server
     * @param itemIds
     * @param {string} dataSetType
     * @returns {Observable<any>}
     */
    getItemsById(itemIds: any, dataSetType: string): Observable<any> {
        let storedtoken = localStorage.getItem('nodetoken');
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedtoken);

        let tempIdList: string = '';

        for (let i = 0; i < itemIds.length; i++) {
            tempIdList += 'objectIds=' + itemIds[i] + '&';
        }

        return this.http.get(storedendpoint.apiendpoint + 'organizations/' + dataSetType + '/objects?' + tempIdList, {headers: headers})
            .map((response) => {
                let results: any = response.json();
                return results;
            });
    }

    /**
     * Gets file infos from server
     * @param {string} ObjId
     * @param {string} orgaStruct
     * @returns {Observable<any>}
     */
    fileInfos(ObjId: string, orgaStruct: string) {
        let storedtoken = localStorage.getItem('nodetoken');
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedtoken);

        ObjId = ObjId.replace(':', '-');

        return this.http.get(storedendpoint.apiendpoint + 'organizations/' + orgaStruct + '/objects/' + encodeURI(ObjId) + '/fileinfos', {headers: headers})
            .map((response) => {
                let results: any = response.json();
                return results;
            });
    }

    /**
     * Gets file from server
     * @param {string} ObjId
     * @param fileObj
     * @param {string} orgaStruct
     * @param {string} fileName
     */
    getFile(ObjId: string, fileObj: any, orgaStruct: string, fileName?: string) {
        let storedendpoint = JSON.parse(localStorage.getItem('appconfig'));

        let url: string;
        let loader = this.loadingCtrl.create({});
        loader.present();

        let storedtoken = localStorage.getItem('nodetoken');
        let headers = new Headers();
        headers.append('X-NODE-TOKEN', storedtoken);

        ObjId = ObjId.replace(':', '-');

        if (!fileName) {
            url = storedendpoint.apiendpoint + 'organizations/' + orgaStruct + '/objects/' + ObjId + '/files' + '?X-NODE-TOKEN=' + storedtoken + '';
        } else {
            url = storedendpoint.apiendpoint + 'organizations/' + orgaStruct + '/objects/' + ObjId + '/files' + '?X-NODE-TOKEN=' + storedtoken + '&filename=' + fileName;
        }
    }
}




// WEBPACK FOOTER //
// ./src/providers/search.ts